import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { YES_NO_QUESTIONS } from "./careersConfig";
import { RequiredMark, YesNo, sectionBorder } from "./careersUi";

export function InterviewSection({ form, set, isMissing }) {
  const hasMissing = YES_NO_QUESTIONS.some((q) => isMissing(q.k)) || isMissing("why_sandar_sushi");
  return (
    <div className={`bg-white p-6 rounded-2xl border ${sectionBorder(hasMissing)} space-y-5`}>
      <div>
        <h2 className="font-display font-semibold text-lg">Interview Questions</h2>
        <p className="text-sm text-neutral-500 mt-1">All Yes / No questions are required.</p>
      </div>

      {YES_NO_QUESTIONS.map(({ k, label }) => (
        <div key={k} className={`flex flex-wrap items-center justify-between gap-3 py-3 border-b border-neutral-100 last:border-0 ${isMissing(k) ? "bg-amber-50/50 -mx-3 px-3 rounded-lg" : ""}`}>
          <Label className="flex-1 min-w-[240px] text-sm font-medium">{label}<RequiredMark/></Label>
          <YesNo value={form[k]} onChange={(v) => set(k, v)} testId={`careers-${k.replace(/_/g, "-")}`}/>
        </div>
      ))}

      <div><Label>What would you do if you saw unsafe food handling?</Label><Textarea rows={2} value={form.unsafe_food_handling_response} onChange={(e) => set("unsafe_food_handling_response", e.target.value)} data-testid="careers-unsafe-food"/></div>
      <div><Label>If your shift starts at 9 AM, what time would you arrive?</Label><Input value={form.shift_arrival_time} onChange={(e) => set("shift_arrival_time", e.target.value)} placeholder="e.g. 8:45 AM" data-testid="careers-arrival"/></div>
      <div><Label>What would you do if you're going to be late or miss a shift?</Label><Textarea rows={2} value={form.late_or_miss_shift_response} onChange={(e) => set("late_or_miss_shift_response", e.target.value)} data-testid="careers-late"/></div>
      <div className={isMissing("why_sandar_sushi") ? "-mx-3 px-3 py-2 rounded-lg bg-amber-50/50" : ""}>
        <Label>Why do you want to work at SANDAR Sushi?<RequiredMark/></Label>
        <Textarea rows={3} value={form.why_sandar_sushi} onChange={(e) => set("why_sandar_sushi", e.target.value)} data-testid="careers-why" className={isMissing("why_sandar_sushi") ? "border-amber-400" : ""}/>
      </div>
    </div>
  );
}
